import { render } from "./FleetOutboundCampaign.vue?vue&type=template&id=70d63838&scoped=true"
import script from "./FleetOutboundCampaign.vue?vue&type=script&lang=js"
export * from "./FleetOutboundCampaign.vue?vue&type=script&lang=js"

import "./FleetOutboundCampaign.vue?vue&type=style&index=0&id=70d63838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d63838"]])

export default __exports__